import { FC } from 'react';
import { useHistory } from 'react-router';

import okHandImg from 'assets/brand/ok-hand.png';
import Button from 'components/_core/Button';
import SunshineModal, {
  SunshineModalProps,
} from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';

import locales from './locales';

const ConfirmationModal: FC<Omit<SunshineModalProps, 'children'>> = (props) => {
  const { onClose } = props;
  const history = useHistory();

  const onConfirm = async () => {
    onClose();
    history.replace('/');
  };

  return (
    <SunshineModal {...props}>
      <SunshineModal.Header />

      <SunshineModal.Body alignItems="center">
        <SunshineModal.Body.Image src={okHandImg} />

        <SunshineModal.Title>{locales.title}</SunshineModal.Title>

        <Text variant="primary">{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button onClick={onConfirm}>{locales.confirm}</Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default ConfirmationModal;
